/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IChoiceGroupOptionStyles } from '@fluentui/react/lib/ChoiceGroup';
import { IPersonaStyles } from '@fluentui/react/lib/Persona';
import { IStackItemStyles, IStackStyles, IStackTokens } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';

export const getLabelStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            marginTop: '-6px',
            marginLeft: '2.4rem',
        },
    };
};

export const getWarningStyles = (theme: ITheme): Partial<IStackStyles> => {
    return {
        root: { color: theme.palette.red },
    };
};

export const getLabelTokens = (): Partial<IStackTokens> => {
    return { childrenGap: '0.75rem' };
};

export const getStackItemStyles = (theme: ITheme): Partial<IStackItemStyles> => {
    return {
        root: {
            color: theme.palette.neutralDark,
        },
    };
};

export const getPersonaStyles = (): Partial<IPersonaStyles> => {
    return {
        root: {
            selectors: {
                '.ms-Persona-initials': {
                    borderRadius: '1.33px',
                },
            },
        },
    };
};

export const getChoiceGroupOptionStyles = (): Partial<IChoiceGroupOptionStyles> => {
    return { root: { marginBottom: '1.25rem' } };
};

export const getFooterStyles = (): Partial<IStackStyles> => {
    return {
        root: { flexDirection: 'row-reverse' },
    };
};
